var internal = {
  alreadyInitialized: false // Initialize the flag

};
var external = {
  initialize: function initialize(settings) {
    if (internal.alreadyInitialized) return;
    internal.alreadyInitialized = true;
    var sovrnData = {
      tags: settings.relevantMetadata,
      category: settings.contentType,
      postid: settings.itemId
    };
    internal.loadProperties(sovrnData);
  }
};

internal.loadProperties = function (sovrnData) {
  if (properSpecialOps) {
    properSpecialOps.page_meta = {
      "tags": sovrnData.tags,
      "category": sovrnData.category
    };
    properSpecialOps.post_id = sovrnData.postid; // Updated to use sovrnData.PostId
  }
};

export { external as default };